import { Tooltip } from "@/components/ui/tooltip";
import { BOUser } from "@/pages/role-asignation/schema/role-assignation.schema";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";

interface Props {
  item: BOUser;
  handleEditAssignation: (id?: string) => void;
}

export const RoleAssignationActions = ({
  handleEditAssignation,
  item,
}: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={
        <Text color={AppColors.WHITE_SECONDARY} fontSize="14px">
          Asignar roles
        </Text>
      }
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <PenLine
        cursor="pointer"
        onClick={() => handleEditAssignation(item?.usuario)}
      />
    </Tooltip>
  );
};
